import { Component } from '@angular/core';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false
})
export class UnauthorizedComponent {
  constructor(
    private router: Router,
    private keycloak: Keycloak
  ) {}

  goBack(): void {
    this.router.navigate(['/dashboard']);
  }

  logout(): void {
    this.keycloak.logout({ redirectUri: window.location.origin });
  }
}
